import React from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { useTenant } from "@/lib/tenant";
import { PageHeader, Panel, Empty } from "@/components/Bits";
import { Progress } from "@/components/ui/progress";

export default function Compliance() {
  const { tenantId } = useTenant();
  const { data } = useQuery({
    queryKey: ["compliance", tenantId],
    queryFn: () => api.get(`/compliance/${tenantId}`).then((r) => r.data),
    enabled: !!tenantId,
  });

  if (!tenantId) return <Empty msg="Select an MSP tenant" />;
  if (!data) return <Empty msg="Loading…" />;

  return (
    <>
      <PageHeader title="Compliance" kicker={`CIS Benchmark · Overall ${data.score}%`} />
      <div className="p-6 grid grid-cols-1 md:grid-cols-2 gap-4">
        {data.controls.map((c) => {
          const pct = Math.round((c.pass / (c.total || 1)) * 100);
          const tone = pct >= 90 ? "text-emerald-400" : pct >= 70 ? "text-yellow-400" : "text-red-400";
          return (
            <Panel key={c.code} className="p-4">
              <div className="flex items-center justify-between mb-3">
                <div>
                  <div className="font-mono text-[10px] uppercase tracking-widest text-cyan-300">{c.code}</div>
                  <div className="font-semibold text-sm">{c.name}</div>
                </div>
                <div className={`font-display text-2xl font-extrabold ${tone}`}>{pct}%</div>
              </div>
              <Progress value={pct} className="h-1.5 bg-white/5" />
              <div className="text-[11px] font-mono text-zinc-500 mt-2">{c.pass} / {c.total} endpoints passing</div>
            </Panel>
          );
        })}
      </div>
    </>
  );
}
